/* eslint-disable react-refresh/only-export-components -- provider + re-exports */
import { useCallback, useMemo, useState, lazy, Suspense } from 'react';
import { ChatPanelContext } from './chatPanelContext';

const ChatPanelLazy = lazy(() =>
    import('../components/ChatPanel').then((m) => ({ default: m.ChatPanel })),
);

export function ChatProvider({ children }) {
    const [isPanelOpen, setPanelOpen] = useState(false);
    /** Optional reply preview for composer (e.g. critical alert context); not shown in the textarea. */
    const [pendingComposerDraft, setPendingComposerDraftState] = useState(null);

    const openPanel = useCallback(() => setPanelOpen(true), []);
    const closePanel = useCallback(() => setPanelOpen(false), []);
    const togglePanel = useCallback(() => setPanelOpen((o) => !o), []);

    const setPendingComposerDraft = useCallback((payload) => {
        setPendingComposerDraftState(payload);
    }, []);

    const clearPendingComposerDraft = useCallback(() => {
        setPendingComposerDraftState(null);
    }, []);

    const value = useMemo(
        () => ({
            isPanelOpen,
            setPanelOpen,
            openPanel,
            closePanel,
            togglePanel,
            pendingComposerDraft,
            setPendingComposerDraft,
            clearPendingComposerDraft,
        }),
        [
            isPanelOpen,
            openPanel,
            closePanel,
            togglePanel,
            pendingComposerDraft,
            setPendingComposerDraft,
            clearPendingComposerDraft,
        ],
    );

    return (
        <ChatPanelContext.Provider value={value}>
            {children}
            <Suspense fallback={null}>
                <ChatPanelLazy />
            </Suspense>
        </ChatPanelContext.Provider>
    );
}

export { useChatPanel, useChatPanelOptional } from './chatPanelContext';
